export default __webpack_public_path__ + "static/top-a1844976e7d787d253cfa168fd2be1fe.png";